import React from 'react';
import { Shield, Award } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Discount = () => {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl shadow-xl overflow-hidden border-2 border-green-200">
          <div className="px-6 py-12 sm:px-12 lg:py-16 lg:px-16 lg:flex lg:items-center lg:justify-between">
            <div className="lg:flex-1">
              <div className="flex items-center mb-4">
                <div className="flex-shrink-0">
                  <Shield className="h-12 w-12 text-green-600" />
                </div>
                <div className="ml-4">
                  <Award className="h-12 w-12 text-green-600" />
                </div>
              </div>
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                Thank You For Your Service
              </h2>
              <p className="mt-4 text-lg text-gray-700">
                We honor those who serve our community and country. <span className="font-bold text-green-700">{businessInfo.discount.eligible}</span> receive a special <span className="font-bold text-green-700">{businessInfo.discount.amount} discount</span> on all detailing services.
              </p>
            </div>
            <div className="mt-8 lg:mt-0 lg:ml-8">
              <div className="inline-flex rounded-lg shadow-lg">
                <div className="bg-green-600 text-white px-8 py-6 rounded-lg text-center">
                  <div className="text-5xl font-bold">{businessInfo.discount.amount}</div>
                  <div className="text-lg font-semibold mt-2">OFF</div>
                  <div className="text-sm mt-1 opacity-90">All Services</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discount;
